module.exports = {
	"config": {
		"siteTitle": "Bit Bye Bit",
		"siteDescr": "Web developer, programmer, musician & cook. This site is about the\nfirst two. Python, Javascript with an emphasis on ReactJS. I like to try to make\nthings that haven't been created yet.",
		"siteAuthor": "Brandon Carrol McKimmons",
		"siteTelegramUrl": "https://t.me/ideletemyself",
		"siteTwitterUrl": "https://twitter.com/ideletemyself",
		"siteGithubUrl": "https://github.com/ideletemyself",
		"siteLinkedinUrl": "https://www.linkedin.com/in/brandonmckimmons/",
		"siteFacebookUrl": "https://www.facebook.com/ideletemyself",
		"googleAnalyticsId": "UA-91027545-2",
		"linkPrefix": "/bit-bye-bit"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-03-thar-she-blows",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-03-thar-she-blows",
				"stem": "index",
				"path": "articles/2017-02-03-thar-she-blows/index.md"
			},
			"requirePath": "articles/2017-02-03-thar-she-blows/index.md",
			"path": "/thar-she-blows/",
			"data": {
				"title": "Thar She Blows!",
				"date": "2017-03-02T22:12:03.284Z",
				"layout": "post",
				"path": "/thar-she-blows/",
				"category": "web development",
				"description": "Python Tornado, ReactJS, react-toolbox and why I keep chasing that asyncronous white whale."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-03-thar-she-blows-part2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-03-thar-she-blows-part2",
				"stem": "index",
				"path": "articles/2017-04-03-thar-she-blows-part2/index.md"
			},
			"requirePath": "articles/2017-04-03-thar-she-blows-part2/index.md",
			"path": "/thar-she-blows-part2/",
			"data": {
				"title": "Thar She Blows!... Part 2",
				"date": "2017-03-04T22:12:03.284Z",
				"layout": "post",
				"path": "/thar-she-blows-part2/",
				"category": "web development",
				"description": "The 2nd part of my blog about my recent project built cutting edge technology where I try to draw some conclusions and describe some of the things I would've done differently."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-28-02-not-another-blog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-28-02-not-another-blog",
				"stem": "index",
				"path": "articles/2017-28-02-not-another-blog/index.md"
			},
			"requirePath": "articles/2017-28-02-not-another-blog/index.md",
			"path": "/not-another-blog/",
			"data": {
				"title": "Not Another Blog.",
				"date": "2017-02-28T22:12:03.284Z",
				"layout": "post",
				"path": "/not-another-blog/",
				"category": "web development",
				"description": "Why I switched from JekyllRB to GatsbyJS and why I think ReactJS & Webpack with PostCSS are all that and a bag of chips."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/projects",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/projects",
				"stem": "index",
				"path": "pages/projects/index.md"
			},
			"requirePath": "pages/projects/index.md",
			"path": "/projects/",
			"data": {
				"title": "Projects",
				"layout": "page",
				"path": "/projects"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/skills",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/skills",
				"stem": "index",
				"path": "pages/skills/index.md"
			},
			"requirePath": "pages/skills/index.md",
			"path": "/skills/",
			"data": {
				"title": "Skills",
				"layout": "page",
				"path": "/skills"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0